import Component from '../classes/Component';

export default class MobileMenu extends Component {
	constructor() {
		super({
			element: '.header',
			elements: {
				hamburgerWrapper: '.header__hamburger',
				hamburger: '.icon--hamburger',
				mobileOverlay: document.querySelector('.mobile-menu-overlay'),
				mobileMenu: document.querySelector('.mobile-menu'),
				mobileMenuFirstLink: document.querySelector('.mobile-menu .menu-item a'),
			},
		});
		this._addEventListener();
	}

	_toggleMobileMenu() {
		this.elements.mobileMenu.classList.toggle('mobile-menu--open');
		this.elements.mobileOverlay.classList.toggle('mobile-menu-overlay--open');

		this.elements.mobileMenuFirstLink.focus();
	}

	_closeMobileMenu() {
		this.elements.mobileMenu.classList.remove('mobile-menu--open');
		this.elements.hamburger.classList.remove('hidden');
		this.elements.mobileOverlay.classList.remove('mobile-menu-overlay--open');
	}

	_checkKeys(event) {
		const KEYCODE = {
			ESC: 27,
		};

		if (event.keyCode === KEYCODE.ESC) {
			this._closeMobileMenu();
		}
	}

	_addEventListener() {
		this.elements.hamburgerWrapper.addEventListener('click', this._toggleMobileMenu.bind(this));
		document.addEventListener('keydown', this._checkKeys.bind(this));

		const iconClose = document.querySelector('.icon--close');

		iconClose.addEventListener('click', () => {
			this._closeMobileMenu();
		});
		this.elements.mobileOverlay.addEventListener('click', (e) => {
			this._closeMobileMenu();
		});
	}
}
